document.addEventListener("DOMContentLoaded", async function () {
  const profile = await loadProfile();
  // Boy is pre-selected by default; the character row shows that gender's characters.
  let selectedGender = profile?.gender || "BOY";
  let selectedTone = profile?.skinTone || "light";

  const childNameInput = document.getElementById("childName");
  const nameError = document.getElementById("name-error");
  const buttons = document.querySelectorAll(".select-option");
  const continueBtn = document.getElementById("continue-btn");
  const charWrap = document.getElementById("character-options");
  const CHARS = window.BEDTIME_CHARS || {};

  function validateName(name) {
    if (name.includes(" ")) {
      return "Please enter only a first name without spaces.";
    }
    if (name.length > 10) {
      return "Your first name must not exceed 10 characters.";
    }
    if (!/^[A-Z][a-z]+$/.test(name)) {
      if (!/^[A-Za-z]+$/.test(name)) {
        return "Name must contain only alphabets.";
      }
      return "First letter should be uppercase, the rest lowercase (e.g., Moiz).";
    }
    return null;
  }

  function checkForm() {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (errorMsg) {
      nameError.textContent = errorMsg;
      nameError.style.display = "block";
      continueBtn.disabled = true;
    } else {
      nameError.style.display = "none";
      if (selectedGender) {
        continueBtn.disabled = false;
      }
    }
  }

  function renderCharacters() {
    if (!charWrap) return;
    const list = CHARS[selectedGender] || [];
    // keep the chosen tone if this gender has it, otherwise fall back to the first character
    if (!list.some((c) => c.tone === selectedTone)) {
      selectedTone = (list[0] && list[0].tone) || "light";
    }
    charWrap.innerHTML = "";
    list.forEach((c) => {
      const card = document.createElement("button");
      card.type = "button";
      card.className = "character-card" + (c.tone === selectedTone ? " active" : "");
      card.setAttribute("aria-label", c.label);
      const img = new Image();
      img.src = c.img;
      img.alt = c.label;
      card.appendChild(img);
      card.addEventListener("click", function () {
        selectedTone = c.tone;
        renderCharacters();
        checkForm();
      });
      charWrap.appendChild(card);
    });
  }

  function markActiveGender() {
    buttons.forEach((btn) => {
      btn.classList.toggle("active", btn.getAttribute("data-gender") === selectedGender);
    });
  }

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      selectedGender = this.getAttribute("data-gender");
      markActiveGender();
      renderCharacters();
      checkForm();
    });
  });

  childNameInput.addEventListener("change", function () {
    checkForm();
  });
  childNameInput.value = profile?.name || '';
  markActiveGender();
  renderCharacters();
  checkForm();

  continueBtn.addEventListener("click", async function () {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (!errorMsg && selectedGender) {
      await saveProfile({
        name : name,
        gender: selectedGender,
        skinTone: selectedTone,
        dedicationText : `Dear ${name},\n\nThis book was made especially for you.\nMay your days be filled with laughter,\nyour heart be filled with kindness,\nand your nights be filled with peaceful sleep.\n\nWe love you very much.\n\nLove,\nMum & Dad`,
        imageBase64 : ""
      });
      window.location.href = "/pages/preview-bedtime";
    }
  });
});
